"use strict";function makeMiniCourse$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.makeMiniCourse$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.edu.makeMiniCourse";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"6.0.15"},_a[ddSdk_1.ENV_ENUM.android]={vs:"6.0.15"},_a)),exports.makeMiniCourse$=makeMiniCourse$,exports.default=makeMiniCourse$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/edu/makeMiniCourse.js
// module id = 949
// module chunks = 106